import { createContext, useContext } from 'react';
import { AppStore } from './app.store';

/**
 * Global
 */
declare global {
  interface Window {
    oldScroll: number;
  }
}

/**
 * Store Context
 */
const StoreContext = createContext<AppStore>(null);

/**
 * Use Store
 */
const useStore = () => useContext(StoreContext);

export { StoreContext, useStore };
